import rootStore from "csi/state/rootStore";
import { Button, FlexRowCenter } from "designSystem/index";
import { white } from "designSystem/styles/color";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { observer } from "mobx-react-lite";
import React from "react";

const SaveEnvironments = observer(() => {
	const {
		saveAsNewEnvironment,
		environmentCanReset,
		saveEnvironmentChanges,
		isSelectedEnvirionmentCentricStudio,
	} = rootStore.threeDStore.environmentsStore;

	return (
		<FlexRowCenter
			bgcolor={white[50]}
			borderTop={STANDARD_BORDER_STYLE}
			bottom={0}
			gap={2}
			justifyContent="space-between"
			p={3}
			position="sticky"
		>
			<Button
				design="secondary"
				disabled={!environmentCanReset}
				fullWidth
				onClick={saveAsNewEnvironment}
				res="SaveAsNew"
			/>
			{ !isSelectedEnvirionmentCentricStudio && (
				<Button
					design="primary"
					disabled={!environmentCanReset}
					fullWidth
					onClick={saveEnvironmentChanges}
					res="SaveChanges"
				/>
			)}
		</FlexRowCenter>
	);
});

export default SaveEnvironments;